import { useState, useEffect } from 'react';
import config from '../lib/config';
import { IMatchRoundData } from '@/models/matchRoundData';

export type ICalendar = {
	name: string;
	id: string;
	rounds?: number;
	periods?: number[];
};

export const useRoundsAndCalendars = (matchRoundsData: IMatchRoundData, calendars: ICalendar[]) => {
	const [roundData, setRoundData] = useState<IMatchRoundData | null>(null);
	const [currentRound, setCurrentRound] = useState(matchRoundsData?.currentRound);
	const [currentYear, setCurrentYear] = useState<ICalendar | null>(calendars[0]);
	const initialRoundsCount = calendars[0]?.rounds || matchRoundsData?.currentRound || 0;
	const [roundsCount, setRoundsCount] = useState<number>(initialRoundsCount);

	useEffect(() => {
		if (calendars.length > 0) {
			const firstCalendar = calendars[0];
			setCurrentYear({
				id: firstCalendar.id,
				name: firstCalendar.name,
				rounds: firstCalendar.rounds,
			});
			setRoundsCount(firstCalendar.rounds || matchRoundsData?.currentRound || 0);
		}
	}, [calendars, matchRoundsData]);

	useEffect(() => {
		const fetchRoundData = async () => {
			try {
				const response = await fetch(
					`${config.apiUrl}/wp-json/statsperform/v1/season-round-schedule?tmcl=${currentYear?.id}&round=${currentRound}`,
				);

				const data = await response.json();
				if (data) {
					setRoundData(data);
				} else {
					console.error('Invalid response', data);
				}
			} catch (error) {
				console.error('Error fetching round data', error);
			}
		};

		fetchRoundData();
	}, [currentYear?.id, currentRound]);

	return {
		roundData,
		currentRound,
		setCurrentRound,
		currentYear,
		setCurrentYear,
		roundsCount,
		setRoundsCount,
	};
};
